import { AmenityTypesStateInterface } from '.';

function state(): AmenityTypesStateInterface {
  return {
    amenityTypes: [],
  };
}

export default state;
